export default __webpack_public_path__ + "static/metrics-1-931a837d156c2931da2ee02083fae508.png";